export default function setUserProfileActionCreator(userDuck, personalization) {
  return profile => async dispatch => {
    dispatch({
      type: userDuck.types.SET_PROFILE,
      payload: profile
    });
    personalization.updateUserProfileCache(profile);
  };
}